module.exports = __webpack_public_path__ + "static/img/cont3619.89adc11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3619.jpg
// module id = VdSN
// module chunks = 0